const supplierToPerson = {
  data() {
    return {}
  },

  computed: {
    keyList() {
      return this.formateShowKey()
    },
  },

  methods: {
    formateShowKey() {
      let keyList = []
      if (this.supplementWorkload) {
        if (this.isCountingByPiece || this.isCountingByDay) {
          keyList = ['phoneNo', 'count', 'carriedBike', 'money']
        } else if (this.isCountingByOrder) {
          keyList = ['phoneNo', 'count', 'overDistance', 'carriedBike', 'money']
        } else {
          keyList = ['phoneNo', 'count', 'money']
        }
      }

      if (this.supplementFee) {
        keyList = ['phoneNo', 'money']
      }

      if (this.deductFee) {
        keyList = ['phoneNo', 'deductMoney', 'carriedBike']
      }

      return keyList
    },

    formateCountOrMoney() {
      let countOrMoney = 0

      if (this.supplementWorkload) {
        countOrMoney = this.totalCount
      }
      if (this.supplementFee || this.deductFee) {
        countOrMoney = this.totalMoney
      }

      return countOrMoney
    },

    formateCarriedBikeCount() {
      let carriedBikeCount = 0

      if (this.supplementWorkload) {
        if (this.isCountingByOrder || this.isCountingByDay || this.isCountingByPiece) {
          carriedBikeCount = this.totalCarriedBike
        } else {
          carriedBikeCount = 0
        }
      }

      if (this.deductFee) {
        carriedBikeCount = -this.totalCarriedBike
      }

      return carriedBikeCount
    },

    formateAdjustDetails() {
      const adjustList = []

      this.personList.forEach((person) => {
        var currentPerson = {}
        this.keyList.forEach((key) => {
          currentPerson[key] = person[key]
        })
        adjustList.push(currentPerson)
      })

      return adjustList
    },

    saveAuditResultByPerson() {
      if (
        this.handleError(this.personList.length > 0, '请补充增补人员信息') ||
        this.handleError(this.validDate, '请选择日期') ||
        this.handleError(this.priceId, '请填写价格ID') ||
        this.handleError(this.reasonType, '请选择计费原因') ||
        this.handleError(this.reason, '请说明具体原因')
      )
        return

      const params = {
        // 注意：测试
        countOrMoney: this.formateCountOrMoney(),
        priceId: this.priceId,
        reason: this.reason,
        reasonType: this.reasonType,
        supplierId: this.searchForm.supplierId,
        type: this.adjustType,
        validDate: this.validDate,
        cityCode: this.searchForm.cityCode,
        repairLevel: this.repairLevelList[this.repairLevel] || '',
        repairPrice: this.repairLevelPrice[this.repairLevel],
      }

      params.carriedBikeCount = this.formateCarriedBikeCount()

      // 按单/计次 专用参数
      if (this.countByOrder) {
        params.overDistance = this.totalOverDistance // 需修改
        if (this.priceInfo.anDanJieFeiConfigDo) {
          params.baseDistanceFee = this.priceInfo.anDanJieFeiConfigDo.baseDistanceFee
          params.overDistancePrice = this.priceInfo.anDanJieFeiConfigDo.overDistancePrice
          params.perBikePrice = this.priceInfo.anDanJieFeiConfigDo.perBikePrice
        }
      }

      const fileIds = this.formateFileIDs(this.uploadFileList)
      if (fileIds.length > 0) {
        params.fileIds = fileIds
      }

      const adjustDetails = this.formateAdjustDetails()
      params.adjustDetails = adjustDetails

      this.saveAuditLoading = true

      this.fetch
        .post('saveAuditResultByPerson', params)
        .then((res) => {
          this.saveAuditLoading = false
          this.auditDialogVisible = false
          this.$message.success(res.errMsg || '操作成功')
          this.getDataList()
          this.resetForm()
        })
        .catch(() => {
          this.saveAuditLoading = false
        })
    },

    saveReconsiderationByPerson() {
      if (
        this.handleError(this.personList.length > 0, '请补充增补人员信息') ||
        this.handleError(this.reasonType, '请选择计费原因') ||
        this.handleError(this.reason, '请说明具体原因')
      )
        return

      const params = {
        id: this.currentId,
        countOrMoney: this.formateCountOrMoney(),
        repairLevel: this.repairLevelList[this.repairLevel] || '',
        repairPrice: this.repairLevelPrice[this.repairLevel],
        reasonType: this.reasonType,
        reason: this.reason,
        type: this.auditPendingData.type,
      }

      params.carriedBikeCount = this.formateCarriedBikeCount()

      // 按单/计次 专用参数
      if (this.countByOrder) {
        params.overDistance = this.totalOverDistance
        if (this.priceInfo.anDanJieFeiConfigDo) {
          params.baseDistanceFee = this.priceInfo.anDanJieFeiConfigDo.baseDistanceFee
          params.overDistancePrice = this.priceInfo.anDanJieFeiConfigDo.overDistancePrice
          params.perBikePrice = this.priceInfo.anDanJieFeiConfigDo.perBikePrice
        }
      }

      const fileIds = this.formateFileIDs(this.uploadFileList)
      if (fileIds.length > 0) {
        params.fileIds = fileIds
      }

      const adjustDetails = this.formateAdjustDetails()
      params.adjustDetails = adjustDetails

      this.saveReAuditLoading = true
      this.fetch
        .post('saveReconsiderationByPerson', params)
        .then((res) => {
          this.saveReAuditLoading = false
          this.auditDialogVisible = false
          this.historyDialogVisible = false
          this.getDataList()
          this.resetForm()
          this.$message.success(res.errMsg || '操作成功')
        })
        .catch(() => {
          this.saveReAuditLoading = false
        })
    },
  },
}

export default supplierToPerson
